/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Best_Feature_6Inputs */

const et_plan_best_feature_6 = /** @type {(inputs: Plan_Best_Feature_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI sisustrateegia`)
};

const en_plan_best_feature_6 = /** @type {(inputs: Plan_Best_Feature_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI content strategy`)
};

/**
* | output |
* | --- |
* | "AI content strategy" |
*
* @param {Plan_Best_Feature_6Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_best_feature_6 = /** @type {((inputs?: Plan_Best_Feature_6Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Best_Feature_6Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_best_feature_6(inputs)
	return en_plan_best_feature_6(inputs)
});